




































import { BolsaCompartMinMaxDTO } from '@/interfaces/prescription';
import { getMinMaxBolsasMulticompart } from '@/services/prescription';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '../base-component.vue';
import BagModelQuantityJustifyDialog from './bag-model-quantity-justify-dialog.vue';

@Component({
  components: {
    BagModelQuantityJustifyDialog,
  },
})
export default class BagModelQuantity extends BaseComponent {
  @Prop()
  item: any;

  @Prop()
  public disabled;

  quantidades = new Array();
  minMaxQtdeBolsas: BolsaCompartMinMaxDTO = null;
  openJustifyDialog = false;

  mounted() {
    this.prepareQuantidades();
  }

  prepareQuantidades() {
    this.quantidades = [];
    this.minMaxQtdeBolsas = null;
    if (this.item.isVisualization() && this.item.quantidade) {
      let q = this.item.quantidade;
      this.quantidades.push({ id: q, nome: this.getPrescriptionLabel(q) });
      return;
    }
    if (!this.isBolsaCompartHabilit()) {
      return;
    }
    getMinMaxBolsasMulticompart(this.item.unidade.id).subscribe((res) => {
      this.minMaxQtdeBolsas = res;
      for (let i = res.minPermit; i <= res.maxPermit; i++) {
        this.quantidades.push({ id: i, nome: this.getPrescriptionLabel(i) });
      }
    });
  }

  getPrescriptionLabel(qtde) {
    if (qtde == 1) {
      return '1 Unidade';
    }
    return `${qtde} Unidades`;
  }

  isQtdeOutRangeMinMax(qtde) {
    if (!this.minMaxQtdeBolsas) {
      return null;
    }
    if (
      this.minMaxQtdeBolsas.minConfig == this.minMaxQtdeBolsas.minPermit &&
      this.minMaxQtdeBolsas.maxConfig == this.minMaxQtdeBolsas.maxPermit
    ) {
      return null;
    }
    return qtde < this.minMaxQtdeBolsas.minConfig || qtde > this.minMaxQtdeBolsas.maxConfig;
  }

  private isBolsaCompartHabilit() {
    return (
      this.item.bolsaMulticompart ||
      (this.item && this.item.unidade && this.item.unidade.usoBolsaMulticompart && this.item.unidade.usoBolsaMulticompart.permiteUso)
    );
  }

  private isBolsaCompartExigida() {
    return this.item && this.item.unidade && this.item.unidade.usoBolsaMulticompart && this.item.unidade.usoBolsaMulticompart.exigirUso;
  }

  getMsgMinMaxBolsaMulticompart() {
    let exclusivamente = this.isBolsaCompartExigida()
      ? '\nSomente bolsas multicompartimentadas poderão ser prescritas.'
      : '';
    return `Este cliente está configurado para prescrever entre ${this.item.unidade.minBolsaMulticompart} e ${this.item.unidade.maxBolsaMulticompart} unidade(s) de bolsa(s) multicompartimentada(s). ${exclusivamente}`;
  }

  getMsgMinMaxBolsaMulticompartTooltip() {
    return `${this.getMsgMinMaxBolsaMulticompart()}\nPara outros valores, nosso atendimento esta a disposição para lhe auxiliar.`;
  }

  isShowAlertOutRangeConfirm() {
    return this.item.bolsaMulticompart && this.isQtdeOutRangeMinMax(this.item.quantidade);
  }

  @Watch('item.quantidade')
  private onItemQuantidadeChange(qtde) {
    this.item.justifQuantidade = null;
    if (!qtde) {
      return;
    }
    if (this.item.isVisualization()) {
      return;
    }

    // para dados vindo de copia da prescrição
    if (this.item.quantidadeCopia) {
      if (this.isQtdeOutRangeMinMax(this.item.quantidade)) {
        this.item.quantidade = this.minMaxQtdeBolsas.minConfig;
      }
      this.item.quantidadeCopia = false;
      return;
    }

    if (!this.isShowAlertOutRangeConfirm()) {
      return;
    }
    this.openJustifyDialog = true;
  }

  onCancelJustifyDialog() {
    this.openJustifyDialog = false;
    let outMin = this.item.quantidade < this.minMaxQtdeBolsas.minConfig;
    this.item.justifQuantidade = null;
    this.item.quantidade = outMin ? this.minMaxQtdeBolsas.minConfig : this.minMaxQtdeBolsas.maxConfig;
  }

  onConfirmJustifyDialog(qtde) {
    this.openJustifyDialog = false;
    this.item.quantidade = qtde;
  }

  @Watch('item.bolsaMulticompart')
  private onChangeBolsaMulticompart(val: boolean) {
    if (this.item.isVisualization()) {
      return;
    }
    if (!val) {
      this.item.quantidade = 1;
      this.item.justifQuantidade = null;
    } else {
      this.item.divisaoBolsas = 1;
      if (!this.item.quantidade || this.item.unidade.minBolsaMulticompart > this.item.quantidade || this.item.unidade.maxBolsaMulticompart < this.item.quantidade) {
        this.item.quantidade = this.item.unidade.minBolsaMulticompart;
      }
    }
  }

  @Watch('item.unidade', { immediate: true })
  private onUnidadeChange(unidade) {
    this.prepareQuantidades();
    if (this.item.isVisualization()) {
      return;
    }
    let comMulti = unidade.usoBolsaMulticompart && unidade.usoBolsaMulticompart.exigirUso;
    this.onChangeBolsaMulticompart(comMulti);
    if (comMulti) {
      setTimeout(() => {
        this.item.bolsaMulticompart = comMulti;
      }, 2000);
    } else {
      this.item.bolsaMulticompart = comMulti;
    }
  }
}
